// extracted by mini-css-extract-plugin
export var standaloneTable = "_gj-0";
export var standaloneTableWithBodyFill = "_gj-1";
export var withExtraHeader = "_gj-2";